import { CloseOutlined } from "@ant-design/icons";
import { Flex, Switch, Typography } from "antd";
import React from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import { useRecordFirst } from "../../hooks/useRecordFirst";
import useSpecialityReference from "../../hooks/useSpecialityReference";
import { LC_KEYS } from "../../utils/constants";

/** One-time record-first intro above the patient list; dismissal is remembered per browser. */
const RecordFirstPopover = () => {
  const { sessionTermLower } = useSpecialityReference();
  const { isDemoPath, isMobilePath } = useAppSelector((state) => state.appState);
  const recordFirst = useRecordFirst();
  const [dismissed, setDismissed] = React.useState(
    () => localStorage.getItem(LC_KEYS.RECORD_FIRST_INTRO_SEEN) === "true",
  );

  const dismiss = () => {
    localStorage.setItem(LC_KEYS.RECORD_FIRST_INTRO_SEEN, "true");
    setDismissed(true);
  };

  if (dismissed || isDemoPath || isMobilePath || !recordFirst.available) {
    return null;
  }

  return (
    <div
      style={{
        // Sits in the same Row/Col grid as the buttons above, so its width matches theirs.
        padding: "16px 16px 10px",
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 16,
        textAlign: "left",
      }}
    >
      <Flex align="flex-start" justify="space-between">
        <span style={{ padding: "2px 8px", borderRadius: 6, background: "#dcfce7", color: "#00c950", fontSize: 11 }}>
          New
        </span>
        <CloseOutlined onClick={dismiss} style={{ color: "#90a1b9", cursor: "pointer" }} aria-label="Dismiss" />
      </Flex>
      <Typography.Paragraph style={{ margin: "10px 0 8px", fontSize: 12, lineHeight: 1.5 }}>
        <Typography.Text strong style={{ fontSize: 12 }}>
          Record your {sessionTermLower}s first and add details later.
        </Typography.Text>{" "}
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          You can always change this in Session settings.
        </Typography.Text>
      </Typography.Paragraph>
      <Flex align="center" justify="space-between">
        <Typography.Text strong style={{ fontSize: 12 }}>
          {recordFirst.enabled ? "Turn off" : "Turn on"}
        </Typography.Text>
        <Switch
          size="small"
          checked={recordFirst.enabled}
          loading={recordFirst.saving}
          onChange={recordFirst.setEnabled}
        />
      </Flex>
    </div>
  );
};

export default RecordFirstPopover;
